import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { I18nService } from '../core/i18n.service';

@Component({
  selector: 'app-login-entry-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <section class="page">
      <header class="head card">
        <h1>{{ t('login.entry.title') }}</h1>
        <p>{{ t('login.entry.subtitle') }}</p>
      </header>

      <div class="grid">
        <article class="card">
          <h2>{{ t('login.entry.player.title') }}</h2>
          <p>{{ t('login.entry.player.desc') }}</p>
          <a class="action" routerLink="/player/login">{{ t('login.entry.player.cta') }}</a>
        </article>

        <article class="card">
          <h2>{{ t('login.entry.bo.title') }}</h2>
          <p>{{ t('login.entry.bo.desc') }}</p>
          <a class="action" routerLink="/backoffice/session">{{ t('login.entry.bo.cta') }}</a>
        </article>
      </div>
    </section>
  `,
  styles: `
    .page { padding: 1.2rem; max-width: 980px; margin: 0 auto; }
    .card { border: 1px solid var(--line-soft); border-radius: 12px; background: linear-gradient(180deg, rgba(23, 36, 58, 0.95) 0%, rgba(18, 29, 47, 0.95) 100%); box-shadow: var(--shadow-soft); }
    .head { padding: 1rem; margin-bottom: 0.9rem; }
    .head h1 { margin: 0 0 0.35rem; font-size: 1.52rem; color: var(--text-strong); letter-spacing: 0.01em; }
    .head p { margin: 0; color: var(--text-muted); }
    .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 0.8rem; }
    article { padding: 0.9rem; }
    h2 { margin: 0 0 0.4rem; font-size: 1.1rem; color: #ebf3ff; }
    p { margin: 0 0 0.7rem; color: var(--text-muted); line-height: 1.45; }
    .action { display: inline-block; text-decoration: none; color: #081123; background: linear-gradient(180deg, var(--accent) 0%, var(--accent-strong) 100%); border: 1px solid rgba(138, 184, 255, 0.6); border-radius: 8px; padding: 0.52rem 0.75rem; font-weight: 700; }
    .action:hover { filter: brightness(1.06); }
  `
})
export class LoginEntryPageComponent {
  private readonly i18n = inject(I18nService);

  protected t(key: string, params?: Record<string, string | number | null | undefined>): string {
    return this.i18n.t(key, params);
  }
}
